import React from "react";
import { bindActionCreators } from "redux";
import LoginPage from "../../components/Auth/LoginPage";
import { connect } from "react-redux";
import { getIsLoginLoading, fetchLogin, getCurrentUser, getError } from "../../reducers/login";

const LoginContainer = props => <LoginPage {...props} />;

const mapState = (state, props) => ({
 isLoading: getIsLoginLoading(state),
 currentUser: getCurrentUser(state),
 error: getError(state)
});

const actions = (dispatch, props) => ({
    login: bindActionCreators(fetchLogin, dispatch),
});

export default connect(mapState, actions)(LoginContainer);
